// extracted by mini-css-extract-plugin
export default {"container":"DesktopNavItems_container__CVp3w","container__item":"DesktopNavItems_container__item__LBQ1q","item__label":"DesktopNavItems_item__label__+Hxw4"};